<template>
  <div class="row position-relative" ref="scrollComponent" id="scrollComponent">
    <Product :product="product"  v-for="product in list" @addProductToCart="addProductToCart" :key="product.id" />
  </div>
</template>

<script>
import Product from '../components/Product'

export default {
  name: "infiniteScroll",
  components: {Product},
  props: ['items'],
  data() {
    return {
      list: [],
      endScroll: false,
      page: 1,
      per_page: 20,
    }
  },
  created() {
    this.loadData();
  },
  mounted() {
     window.addEventListener("scroll", this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll)

  },
  watch: {
    items() {
      this.page = 1;
      this.list = []
      this.endScroll = false
      this.loadData()
      // this.$refs.scrollComponent.scrollIntoView({behavior: 'smooth', block: 'start'})
    },
  },
  methods: {
    loadData() {
      const start = (this.page - 1) * this.per_page;
      const end = this.page * this.per_page;
      const newItems = Object.values(this.items).slice(start, end);
      if (!newItems.length) {
        this.endScroll = true;
      } else {
        this.list.push(...newItems)
      }
    },
    addProductToCart(product){
      this.$emit('addProductToCart',product)
    },
    handleScroll() {
      if (this.endScroll) {
        return;
      }
      let element = this.$refs.scrollComponent;
      if (element.getBoundingClientRect().bottom < window.innerHeight) {
        this.page++;
        this.loadData()
      }
    }
  }
}
</script>
